import { Sparkles, X, CheckCircle } from 'lucide-react'
import '../Pages.css'

export default function LeadEnrichmentSuggestion({ suggestion, onApply, onDismiss }) {
  if (!suggestion) return null

  const confidenceConfig = {
    high: { label: 'High Confidence', bg: 'rgba(5, 150, 105, 0.1)', color: '#059669' },
    medium: { label: 'Medium Confidence', bg: 'rgba(217, 119, 6, 0.1)', color: '#d97706' },
    low: { label: 'Low Confidence', bg: 'rgba(100, 116, 139, 0.1)', color: '#64748b' }
  }

  const conf = confidenceConfig[suggestion.confidence] || confidenceConfig.low

  return (
    <div className="lead-enrichment-banner">
      <div className="lead-enrichment-banner-icon">
        <Sparkles size={20} style={{ color: '#8b5cf6' }} />
      </div>
      <div className="lead-enrichment-banner-body">
        <div className="lead-enrichment-banner-title">
          Timezone Detected
          <span
            className="lead-enrichment-confidence"
            style={{ background: conf.bg, color: conf.color }}
          >
            {conf.label}
          </span>
        </div>
        <p className="lead-enrichment-banner-desc">
          Based on {suggestion.leadsCount} leads, we detected{' '}
          <strong>{suggestion.detectedTimezone}</strong> as the likely timezone.
          {suggestion.sampleDomains?.length > 0 && (
            <> Sample domains: {suggestion.sampleDomains.join(', ')}.</>
          )}
        </p>
      </div>
      <div className="lead-enrichment-banner-actions">
        <button
          className="btn btn-ai"
          onClick={() => onApply(suggestion.detectedTimezone)}
          style={{ fontSize: '0.825rem', padding: '0.45rem 0.875rem' }}
        >
          <CheckCircle size={14} />
          Apply {suggestion.detectedTimezone} to Schedule
        </button>
        <button
          className="btn btn-ghost"
          onClick={onDismiss}
          style={{ fontSize: '0.825rem', padding: '0.45rem 0.875rem' }}
        >
          Dismiss
        </button>
      </div>
      <button
        onClick={onDismiss}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: 'var(--color-text-muted)',
          padding: '0.25rem',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <X size={16} />
      </button>
    </div>
  )
}
